import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

const QuickActionPanel = ({ actions = [] }) => {
  const navigate = useNavigate();

  const colorClasses = {
    primary: 'bg-primary/10 text-primary hover:bg-primary/20',
    secondary: 'bg-secondary/10 text-secondary hover:bg-secondary/20',
    accent: 'bg-accent/10 text-accent hover:bg-accent/20',
    success: 'bg-success/10 text-success hover:bg-success/20'
  };

  const handleActionClick = (path) => {
    navigate(path);
  };

  if (!actions?.length) {
    return (
      <div className="p-6 rounded-lg border border-border bg-muted/30 text-sm text-muted-foreground text-center">
        No suggested actions yet. As you add data and events, we will surface the next best moves here.
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      {actions?.map((action, idx) => (
        <button
          key={`${action?.path || action?.title || 'action'}-${idx}`}
          onClick={() => handleActionClick(action?.path)}
          className={`
            p-6 rounded-lg border border-border
            ${colorClasses?.[action?.color]}
            transition-smooth text-left
            hover:shadow-card
            flex flex-col h-full
          `}
        >
          <div className="flex items-start justify-between mb-4">
            <div className={`
              w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0
              ${action?.color === 'primary' ? 'bg-primary/20' : ''}
              ${action?.color === 'secondary' ? 'bg-secondary/20' : ''}
              ${action?.color === 'accent' ? 'bg-accent/20' : ''}
              ${action?.color === 'success' ? 'bg-success/20' : ''}
            `}>
              <Icon name={action?.icon} size={24} />
            </div>
            {action?.progress !== undefined && (
              <span className="text-sm font-semibold">
                {action?.progress}%
              </span>
            )}
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-foreground mb-1">
              {action?.title}
            </h3>
            <p className="text-sm text-muted-foreground">
              {action?.description}
            </p>
          </div>
          {action?.progress !== undefined && (
            <div className="mt-4 w-full bg-muted/50 rounded-full h-1.5 overflow-hidden">
              <div
                className={`h-full transition-all duration-300 ease-out rounded-full ${
                  action?.color === 'primary' ? 'bg-primary' : ''
                }${
                  action?.color === 'secondary' ? 'bg-secondary' : ''
                }`}
                style={{ width: `${action?.progress}%` }}
              ></div>
            </div>
          )}
        </button>
      ))}
    </div>
  );
};

export default QuickActionPanel;